import type { ReactNode } from 'react'

export enum THEME_LISTENERS {
  REFRESH_THEME = 'refresh_theme'
}

export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark'
}

export type ThemeContextProps = {
  theme: ThemeMode
}

export type ThemeProviderProps = {
  children: ReactNode
}
